var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61682 9.02847H10.2656L13.7475 12.5247C14.0842 12.8612 14.0842 13.4111 13.7475 13.7476C13.4108 14.0841 12.8606 14.0841 12.5239 13.7476L9.03376 10.2596V9.61118L8.81204 9.38138C7.66235 10.3662 6.09385 10.8751 4.42681 10.5961C2.14386 10.2103 0.320784 8.30623 0.041574 6.00821C-0.385452 2.53655 2.53804 -0.385226 6.01173 0.0415496C8.3111 0.320596 10.2163 2.1426 10.6023 4.42421C10.8815 6.09028 10.3723 7.65786 9.38688 8.80687L9.61682 9.02847ZM1.64292 5.33521C1.64292 7.37882 3.29354 9.02847 5.33834 9.02847C7.38314 9.02847 9.03376 7.37882 9.03376 5.33521C9.03376 3.29161 7.38314 1.64196 5.33834 1.64196C3.29354 1.64196 1.64292 3.29161 1.64292 5.33521Z",
    fill: "#B9C1C8",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDark);
export default __webpack_public_path__ + "static/media/search-dark.991b9c7ec985193b3d10f64de3452ac3.svg";
export { ForwardRef as ReactComponent };